import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../../../api/axios";

function ResetOtpPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const mobileFromState =
    location.state?.mobile_number ||
    sessionStorage.getItem("otp_verified_mobile") ||
    "";

  const [mobile_number] = useState(mobileFromState);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password_confirmation, setPasswordConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!mobile_number) {
      setError("OTP verification required. Please verify your mobile first.");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/api/reset-otp-password", {
        mobile_number,
        email,
        password,
        password_confirmation,
      });
      setMessage(res.data.message);
      sessionStorage.removeItem("otp_verified_mobile");
      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      setError(
        err.response?.data?.message || "Unable to reset password. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!mobile_number) {
    return (
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <div className="card p-4 shadow-lg text-center" style={{ maxWidth: 400, width: "100%" }}>
          <p className="mb-3">Please verify your mobile OTP before resetting your password.</p>
          <Link to="/otp" className="btn btn-primary">
            Verify OTP
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card p-4 shadow-lg" style={{ maxWidth: 400, width: "100%" }}>
        <h2 className="text-center mb-3">Reset Password</h2>
        <p className="text-muted small text-center mb-3">
          Mobile verified: {mobile_number}
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              placeholder="Account email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Confirm password"
              value={password_confirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
              minLength={6}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Saving..." : "Reset Password"}
          </button>
        </form>
        {message && <p className="text-success text-center mt-3">{message}</p>}
        {error && <p className="text-danger text-center mt-3">{error}</p>}
      </div>
    </div>
  );
}

export default ResetOtpPassword;
